import { useEffect, useState } from 'react';

type DebouncedValue<T> = {
  value: T;
  timestamp: number;
};
const DebouncedValue = <T>(value: T) => ({ value, timestamp: Date.now() });
export default <T>(value: T, delay: number): DebouncedValue<T> => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<DebouncedValue<T>>(DebouncedValue(value));

  const valueChanged = value !== debouncedValue.value;
  useEffect(
    () => {
      if (!valueChanged) {
        return;
      }

      // Update debounced value after delay
      const timer = setTimeout(() => {
        setDebouncedValue(DebouncedValue(value));
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(timer);
      };
    },
    [value, delay, valueChanged], // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};
